module.exports = __webpack_public_path__ + "static/media/Abu Dhabi Digital Authority (ADDA)_.0d1fdcb6.jpg";